





































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { OrganisationState, Organisation } from '@/types';
import SearchBar from '@/components/SearchBar.vue';
import Table from '@/components/Table.vue';
import { Action, Getter } from 'vuex-class';
import OrganisationEdit from '@/components/OrganisationEdit.vue';
import OrganisationService from '../services/organisation.service';
import Dialog from '@/components/Dialog.vue';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import {RouterHelper} from '@/router';
@Component({
  components: {
    ConfirmButton,
    CancelButton,
    GenericButton,
    Dialog,
    SearchBar,
    OrganisationEdit,
    Table,
  },
})
export default class OrganisationList extends Vue {
  private organisation: any = {};
  private showOrganisationDialog: boolean = false;
  private showCreateOrganisationDialog: boolean = false;
  private isSaving: boolean = false;
  @Getter private activeAccountId: any;
  @Getter private userDetails: any;
  @Getter private hasPermission: any;
  private organisations: any = [];
  private dataTableHeight: number = 100;
  private table = {
    headers: [
      { text: 'Id', value: 'id'},
      { text: 'Name', value: 'name'},
      { text: 'Billing account', value: 'billing_account'},
      { text: 'No. projects', value: 'projects_total'},
      { text: 'No. active devices', value: 'devices_active'},
      { text: 'No. devices in stock', value: 'devices_stock'},
      { text: 'No. users', value: 'users_total'},
      { text: 'Actions', value: 'actions'},
    ],
    options: {
      itemsPerPage: 25,
    },
  };

  private async mounted() {
    await this.getOrganisations();
  }

  private async goToOrganisation(organisation: Organisation) {
    await RouterHelper.switchOrganisation(Number(organisation.id));
  }

  private updateDataTableHeight() {
    this.dataTableHeight = (this.$refs.orgCard as any).$el.clientHeight - 40;
  }

  private async editOrganisation(organisation: any) {
    this.organisation = organisation ? organisation : {name: ''};
    this.showOrganisationDialog = true;
  }

  private async close() {
    if (this.isSaving) {
      return;
    }
    await this.getOrganisations();
    this.showOrganisationDialog = false;
  }

  private goToAccount() {
    if (!this.hasPermission('account:view')) {
      return;
    }
    if (this.activeAccountId) {
      this.$router.push(`/account/${this.activeAccountId}/summary`);
    } else {
      this.$router.push(`/account/0/summary`);
    }
  }

  private async getOrganisations() {
    const organisations = await OrganisationService.getOrganisations();
    this.organisations = organisations.map((o: any) => ({
      ...o,
      billing_account: o.billing_account ? `${o.billing_account.name}${o.billing_account.legal_entity_name && o.billing_account.legal_entity_name !== o.billing_account.name ? ` (${o.billing_account.legal_entity_name})` : ''}` : '(Not set)',
    }));
  }

  private async save() {
    if (this.$refs.orgEdit) {
      await (this.$refs.orgEdit as OrganisationEdit).save();
    }
  }
}
